import React from 'react';
import { certifications } from '../data/certifications';
export function CertificationsBand() {
  return <section aria-labelledby="certifications-heading" className="border-b border-line bg-surface" data-id="element-38" data-mp="2nomiynq7sadq">
      <div className="mx-auto grid max-w-7xl gap-8 px-6 py-12 lg:grid-cols-12 lg:gap-12 lg:px-8" data-id="element-39" data-mp="2ix4evqsw9toj">
        <h2 id="certifications-heading" className="font-display text-xl font-bold leading-tight tracking-tight lg:col-span-3" data-id="element-40" data-mp="2dy06v3hpi1zs">
          Certified to repair it right.
        </h2>
        <ul className="grid gap-8 sm:grid-cols-3 lg:col-span-9" data-id="element-41" data-mp="2403xoh8bxh4b">
          {certifications.map(cert => <li key={cert.name} className="border-l-2 border-accent pl-5 data-[soon=true]:border-line" data-soon={cert.comingSoon} data-id="element-42" data-mp="1zztsh6sd2uqi">
              <p className="flex flex-wrap items-center gap-2" data-id="element-43" data-mp="1v2jw176k1it6">
                <span className={`font-display text-base font-bold ${cert.comingSoon ? 'text-muted' : 'text-ink'}`} data-id="element-44" data-mp="3uct1ui65espc">
                  {cert.name}
                </span>
                {cert.comingSoon && <span className="whitespace-nowrap rounded-full border border-line bg-paper px-2 py-0.5 text-xs font-medium text-muted" data-id="element-45" data-mp="dmg2z1zte5df">
                    Coming soon
                  </span>}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-46" data-mp="9m5zbvzhvr1q">{cert.detail}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}